"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var StickyHeader_1 = __importDefault(require("./StickyHeader"));
var breakpoints_1 = require("../data/breakpoints");
var Menu = /** @class */ (function () {
    function Menu() {
        var _this = this;
        this.navBar = document.querySelector("[".concat(constants_1.DATA_NAVBAR, "]"));
        if (!this.navBar) {
            return;
        }
        this.submenus = this.navBar.querySelectorAll("[".concat(constants_1.DATA_SUBMENU, "]"));
        this.submenuToggles = this.navBar.querySelectorAll("[".concat(constants_1.DATA_TOGGLE_SUBMENU, "]"));
        this.submenuCloses = this.navBar.querySelectorAll("[".concat(constants_1.DATA_SUBMENU_CLOSE, "]"));
        this.navLinks = this.navBar.querySelectorAll("[".concat(constants_1.DATA_NAV_LINK, "]"));
        this.menuToggle = document.querySelector("[".concat(constants_1.DATA_NAVBAR_TOGGLE, "]"));
        this.menuCollapse = this.navBar.querySelector("[".concat(constants_1.DATA_NAVBAR_COLLAPSE, "]"));
        this.activeNavLink = this.getActiveNavLink();
        this.themeColorMetaTag = document.querySelector('meta[name="theme-color"]');
        this.themeColorMetaTagInitial = this.themeColorMetaTag.getAttribute('content');
        this.initEventListeners();
        // Close menu on orientation change (e.g. on iPad)
        window.addEventListener('resize', function () {
            if (Menu.isOpen) {
                _this.hideMenu();
                Menu.isOpen = !Menu.isOpen;
            }
            _this.hideAllSubmenus();
        });
    }
    Menu.prototype.initEventListeners = function () {
        this.toggleSubmenus();
        this.closeSubmenu();
        this.toggleMenu();
    };
    Menu.prototype.toggleMenu = function () {
        var _this = this;
        this.menuToggle.addEventListener('click', function () {
            Menu.isOpen = !Menu.isOpen;
            if (Menu.isOpen) {
                _this.themeColorMetaTag.setAttribute('content', '#91c260');
                _this.showMenu();
                return;
            }
            _this.hideMenu();
        });
    };
    Menu.prototype.showMenu = function () {
        this.menuToggle.classList.remove(constantsClasses_1.CLASS_COLLAPSED);
        this.menuCollapse.classList.add(constantsClasses_1.CLASS_SHOW);
        StickyHeader_1.default.header.classList.add(constantsClasses_1.CLASS_OPEN, constantsClasses_1.CLASS_STICKY);
        document.body.classList.add(constantsClasses_1.CLASS_NAVBAR_OPEN);
    };
    Menu.prototype.hideMenu = function () {
        this.menuToggle.classList.add(constantsClasses_1.CLASS_COLLAPSED);
        this.menuCollapse.classList.remove(constantsClasses_1.CLASS_SHOW);
        StickyHeader_1.default.header.classList.remove(constantsClasses_1.CLASS_OPEN);
        if (window.scrollY < 1) {
            StickyHeader_1.default.header.classList.remove(constantsClasses_1.CLASS_STICKY);
        }
        document.body.classList.remove(constantsClasses_1.CLASS_NAVBAR_OPEN);
        this.themeColorMetaTag.setAttribute('content', this.themeColorMetaTagInitial);
    };
    /**
     * get current active nav-link
     * @private
     */
    Menu.prototype.getActiveNavLink = function () {
        var activeEl;
        for (var i = 0; i < this.navLinks.length; i++) {
            if (this.navLinks[i].classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
                activeEl = this.navLinks[i];
                break;
            }
        }
        return activeEl ? activeEl : undefined;
    };
    /**
     * closes submenu on outside click of navbar
     * @private
     */
    Menu.prototype.closeSubmenu = function () {
        var _this = this;
        var _a;
        document.addEventListener('click', function (event) {
            var _a;
            var composedPath = event.composedPath();
            var isOutsideClick = true;
            for (var i = 0; i < composedPath.length - 1; i++) {
                if (composedPath[i] === _this.navBar) {
                    isOutsideClick = false;
                    break;
                }
            }
            if (!isOutsideClick) {
                return;
            }
            _this.hideAllSubmenus();
            StickyHeader_1.default.header.classList.remove(constantsClasses_1.CLASS_SHOW_NAV_BG_LAYER);
            // add border to active nav-link
            (_a = _this.activeNavLink) === null || _a === void 0 ? void 0 : _a.classList.add(constantsClasses_1.CLASS_ACTIVE);
        });
        (_a = this.submenuCloses) === null || _a === void 0 ? void 0 : _a.forEach(function (submenuClose) {
            submenuClose.addEventListener('click', function () {
                var id = submenuClose.dataset.submenuClose;
                var submenu = _this.menuCollapse.querySelector("[".concat(constants_1.DATA_SUBMENU, "=\"").concat(id, "\"]"));
                var submenuToggle = _this.menuCollapse.querySelector("[".concat(constants_1.DATA_TOGGLE_SUBMENU, "=\"").concat(id, "\"]"));
                submenuToggle === null || submenuToggle === void 0 ? void 0 : submenuToggle.setAttribute('aria-expanded', 'false');
                submenu === null || submenu === void 0 ? void 0 : submenu.classList.add(constantsClasses_1.CLASS_HIDE_NAV);
            });
        });
    };
    /**
     * hide all submenus and show respective submenu
     * @private
     */
    Menu.prototype.toggleSubmenus = function () {
        var _this = this;
        var _a;
        (_a = this.submenuToggles) === null || _a === void 0 ? void 0 : _a.forEach(function (toggle) {
            var _a;
            // get submenu for nav-link
            var submenu = (_a = toggle === null || toggle === void 0 ? void 0 : toggle.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector("[".concat(constants_1.DATA_SUBMENU, "]"));
            if (!submenu) {
                return;
            }
            toggle.addEventListener('click', function () {
                var _a, _b;
                // if submenu already open on click
                // close open submenu, add border to current nav-link
                // do nothing afterward
                if (toggle.getAttribute('aria-expanded') === 'true') {
                    toggle.classList.remove(constantsClasses_1.CLASS_OPEN);
                    _this.hideAllSubmenus();
                    (_a = _this.activeNavLink) === null || _a === void 0 ? void 0 : _a.classList.add(constantsClasses_1.CLASS_ACTIVE);
                    // Check if none of the toggles are open
                    _this.checkIfNoneOpen();
                    return;
                }
                // When opening a new submenu, hide others
                _this.hideAllSubmenus();
                toggle.setAttribute('aria-expanded', 'true');
                // show submenu for clicked nav-link
                if (submenu.classList.contains(constantsClasses_1.CLASS_HIDE_NAV)) {
                    submenu.classList.remove(constantsClasses_1.CLASS_HIDE_NAV);
                    StickyHeader_1.default.header.classList.add(constantsClasses_1.CLASS_SHOW_NAV_BG_LAYER);
                }
                // if mobile do nothing
                if (window.innerWidth < breakpoints_1.GRID_BREAKPOINTS.lg) {
                    return;
                }
                // remove border from all nav-links
                (_b = _this.navLinks) === null || _b === void 0 ? void 0 : _b.forEach(function (navLink) {
                    if (navLink.classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
                        navLink.classList.remove(constantsClasses_1.CLASS_ACTIVE);
                    }
                    if (navLink.classList.contains(constantsClasses_1.CLASS_OPEN)) {
                        navLink.classList.remove(constantsClasses_1.CLASS_OPEN);
                    }
                });
                // add border for clicked nav-link
                toggle.classList.add(constantsClasses_1.CLASS_OPEN);
                // Check if none of the toggles are open after opening
                _this.checkIfNoneOpen();
            });
        });
    };
    /**
     * Check if none of the submenu toggles are open
     * @private
     */
    Menu.prototype.checkIfNoneOpen = function () {
        var noneOpen = Array.from(this.submenuToggles).every(function (toggle) { return !toggle.classList.contains(constantsClasses_1.CLASS_OPEN); });
        if (noneOpen) {
            StickyHeader_1.default.header.classList.remove(constantsClasses_1.CLASS_SHOW_NAV_BG_LAYER);
        }
    };
    /**
     * hide all submenus
     * @private
     */
    Menu.prototype.hideAllSubmenus = function () {
        var _a, _b, _c;
        (_a = this.submenuToggles) === null || _a === void 0 ? void 0 : _a.forEach(function (toggle) {
            if (toggle.classList.contains(constantsClasses_1.CLASS_OPEN)) {
                toggle.classList.remove(constantsClasses_1.CLASS_OPEN);
            }
        });
        (_b = this.navLinks) === null || _b === void 0 ? void 0 : _b.forEach(function (navLink) {
            navLink.setAttribute('aria-expanded', 'false');
        });
        (_c = this.submenus) === null || _c === void 0 ? void 0 : _c.forEach(function (submenu) {
            if (!submenu.classList.contains(constantsClasses_1.CLASS_HIDE_NAV)) {
                submenu.classList.add(constantsClasses_1.CLASS_HIDE_NAV);
            }
        });
    };
    Menu.isOpen = false;
    return Menu;
}());
exports.default = Menu;
